import {stringify} from 'csv-stringify/browser/esm/sync';
import {buildCsvRows} from '@common/lib/csvRows';

/**
 * Converts an array of flat records to a CSV string (browser entry point).
 * Column order follows `columns` when provided, otherwise uses the keys of the first record.
 *
 * Core logic lives in `@common/lib/csvRows` — this is a thin wrapper that
 * provides the browser-compatible `csv-stringify` import.
 */
export function createCsv(
  records: Record<string, unknown>[],
  columns?: string[],
): string {
  const data = buildCsvRows(records, columns);
  return data.length === 0 ? '' : stringify(data);
}
